import { useCallback } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Listable } from 'listable'
import { trimObjectStrings } from 'utils'
import { useNavigate } from 'react-router-dom'
import Row from './row'
import Filters from '../filters'
import { actions, config, constants } from '../../module'


const List = ({ account, model }) => {

  const navigate = useNavigate()

  const renderItem = useCallback((item, index, itemProps) => {

    const onView = () =>
      navigate(`${constants.PATH_DRILLDOWN}/${item.agreementNo}/contract-details`)

    const onRequestVariation = () =>
      navigate(`${constants.PATH_DRILLDOWN}/${item.agreementNo}/variations`)

    return (
      <Row
        key={index}
        account={account}
        item={trimObjectStrings(item)}
        onView={onView}
        onRequestVariation={onRequestVariation}
        {...itemProps}/>
    )
  }, [account, navigate])

  const { ids, filters, ...rest } = model

  return (
    <Listable
      actions={actions}
      config={{ ...config, title: 'Fleet' }}
      filters={Filters}
      model={rest}
      renderItem={renderItem}/>
  )
}

List.propTypes = {
  account: PropTypes.string,
  model: PropTypes.object.isRequired,
}

const mapStateToProps = ({ fleet, settings }) => ({
  account: settings?.account,
  model: fleet,
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List)
